import React from 'react';
import GenerationHistory from '@pages-clean/shared/generation-history/generation-history';
import Constants from '@utils/constants';
import { LoggedInPageProps } from '@config/routes/interfaces';

const RAMGenerationHistory = ({ organisationKey, study, user }: LoggedInPageProps) => {
    return (
        <GenerationHistory
            module={Constants.Modules.RAM}
            orgKey={organisationKey!}
            studyId={study!.id as string}
            user={user}
        />
    );
};
export default RAMGenerationHistory;
